module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "nav navbar-form mainSearchForm",
    attrs: {
      "id": "mainSearchForm"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internalSearchText),
      expression: "internalSearchText"
    }],
    ref: "mainSearchInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.mainSearchPlaceHolder,
      "required": "required"
    },
    domProps: {
      "value": (_vm.internalSearchText)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "keydown": _vm.changeText,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internalSearchText = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "overInput"
  }, [(_vm.searchOpen || _vm.searchText) ? _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close($event)
      }
    }
  }) : _vm._e(), (!_vm.searchOpen && !_vm.searchText) ? _c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.focus($event)
      }
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a96102a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/HeaderSearchForm.vue
// module id = 1272
// module chunks = 1